import { ObjectClass } from "@app/types";
import React from "react";
import ReactDOM from "react-dom";
import Button from "./Button";
import { defaultServiceContext } from "../contexts";
import { formatDateTime } from "../utilities";
import PropertyPanelWidget from "../widgets/PropertyPanelWidget";
import NodeRegistry from "../utilities/NodeRegistry";

const { avsService } = defaultServiceContext;

export default class About extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sensitive: [],
            emptyDataAccess: [],
            emptyCustom: [],
            initial: null,
            latest: null
        };
    }

    componentDidMount() {
        this.init();
    }

    async init() {
        const sensitive = [];
        const emptyDataAccess = [];
        const emptyCustom = [];
        window.apm.serialized.components.objects.forEach(o => {
            if (o.props.config.sensitiveData) {
                sensitive.push(o);
            }
            if (o._class === ObjectClass.data && !o.props.config.script) {
                emptyDataAccess.push(o);
            }
            if (o._class === ObjectClass.custom && !o.props.config.function.script && !o.props.config.function.ref) {
                emptyCustom.push(o);
            }
        });
        this.setState({
            sensitive,
            emptyDataAccess,
            emptyCustom
        });

        const getVersionInfo = async (version) => {
            const design = (version) ? (
                await avsService.getDesign(branchId, version)
            ) : null;
            const time = design?.lastSavedToRepo || design?.lastUpdate;
            return {
                version: design?.version ?? 'UNSAVED',
                time: (time) ? formatDateTime(time) : 'N/A'
            };
        }

        const { branchId } = window.apm.serialized;
        const versions = await avsService.getVersions(branchId);
        const initialVersion = versions[versions.length - 1]?.version;
        const latestVersion = versions[0]?.version;
        const [
            initial,
            latest
        ] = await Promise.all([
            getVersionInfo(initialVersion),
            getVersionInfo(latestVersion),
        ]);

        this.setState({
            initial,
            latest
        });
    }

    openNodeInPopup(node) {
        node = window.apm.getNode(node.id);
        window.apm.popup(node.name,
            '<div class="node_popup_container"></div>',
            '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ',
            [
                ".node_popup_container",

                () => {
                    const proxyNode = new NodeRegistry.r[node["_class"]](node.name, 0, 0, node.props, node.id);
                    proxyNode.setProperty("parentComponentID", node.id);
                    proxyNode.setWriteProxy((key, value) => {
                        const nodeCopy = JSON.parse(JSON.stringify(node));
                        nodeCopy.name = proxyNode.getConfig("name");
                        nodeCopy.props = proxyNode.serialize().props;
                        window.apm.setNode(nodeCopy.id, nodeCopy);
                        window.apm.postEventToAllViews({ target: "request-update-evaluation" });
                        $('#tl_container').jstree().rename_node(node.id, proxyNode.getConfig("name"));
                    });
    
                    this.innerIntervalHandler = setInterval(() => {
                        if($(".node_popup_container")){
                            clearInterval(this.innerIntervalHandler);
                            ReactDOM.render(<PropertyPanelWidget context={proxyNode} embed={true}/>, $(".node_popup_container").get(0));
                        }
                    }, 10);
                    
                }

            ], 
            500
        );
    }

    render() {
        const serialized = window.apm.serialized;
        return <div>
            <Button label="Refresh" callback={() => {
                this.init();
            }} />
            <table className="table table-bordered">
                <tbody>
                <tr>
                    <th rowSpan="5">About</th>
                    <td>Application Name</td>
                    <td>{serialized.client + " " + serialized.application}</td>
                </tr>
                <tr>
                    <td>Application Description</td>
                    <td>{serialized.description}</td>
                </tr>
                <tr>
                    <td>Archetype Version</td>
                    <td>{serialized.version}</td>
                </tr>
                <tr>
                    <td>Initial save date/time</td>
                    <td>{this.state.initial ? `${this.state.initial.version} (${this.state.initial.time})` : "Loading..."}</td>
                </tr>
                <tr>
                    <td>Latest version and save date/time</td>
                    <td>{this.state.latest ? `${this.state.latest.version} (${this.state.latest.time})`: "Loading..."}</td>
                </tr>
                <tr>
                    <th>Authors</th>
                    <td colSpan="2">{serialized.author}</td>
                </tr>
                <tr>
                    <th>Languages</th>
                    <td colSpan="2">{serialized.languages.map(l => l.language).join(", ")}</td>
                </tr>
                <tr>
                    <th rowSpan="10">Counts</th>
                    <td>Module</td>
                    <td>{serialized.components.modules.length}</td>
                </tr>
                <tr>
                    <td>Data Access</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.data).length}</td>
                </tr>
                <tr>
                    <td>Tabular Router</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.tab).length}</td>
                </tr>
                <tr>
                    <td>Input</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.input).length}</td>
                </tr>
                <tr>
                    <td>Prompt</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.prompt).length}</td>
                </tr>
                <tr>
                    <td>Prompt Reference</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.promptReference).length}</td>
                </tr>
                <tr>
                    <td>Save Prompt</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.savePrompt).length}</td>
                </tr>
                <tr>
                    <td>Custom</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.custom).length}</td>
                </tr>
                <tr>
                    <td>Reporting</td>
                    <td>{serialized.components.objects.filter(o => o._class === ObjectClass.report).length}</td>
                </tr>
                <tr>
                    <th>Sensitive</th>
                    <td colSpan="2">{this.state.sensitive.map(o => <div key={"sensitive" + o.id}>
                        <a href="#" onClick={event => {
                            event.preventDefault();
                            this.openNodeInPopup(o);
                        }}>{o.name}</a>
                        <br />
                    </div>)}</td>
                </tr>
                <tr>
                    <th rowSpan="3">Health Check</th>
                    <td>GraphQL Schema implemented?</td>
                    <td>{serialized?.graphQLSchemas?.length > 0 ? "Yes" : "No"}</td>
                </tr>
                <tr>
                    <td>Data Access not complete</td>
                    <td>{this.state.emptyDataAccess.map(o => <div key={"emptyDataAccess" + o.id}>
                        <a href="#" onClick={event => {
                            event.preventDefault();
                            this.openNodeInPopup(o);
                        }}>{o.name}</a>
                        <br />
                    </div>)}</td>
                </tr>
                <tr>
                    <td>Customs not complete</td>
                    <td>{this.state.emptyCustom.map(o => <div key={"emptyCustom" + o.id}>
                        <a href="#" onClick={event => {
                            event.preventDefault();
                            this.openNodeInPopup(o);
                        }}>{o.name}</a>
                        <br />
                    </div>)}</td>
                </tr>
                <tr>
                    <th>Change Log</th>
                    <td colSpan="2">
                        <Button
                            label="Open Change Log"
                            callback={() => {
                                window.apm.getChangeLogDialog();
                            }}
                        />
                    </td>
                </tr>
                <tr>
                    <th>Validation</th>
                    <td colSpan="2">
                        <Button
                            label="Open Validator"
                            callback={() => {
                                window.apm.postEventToCurrentView({
                                    target: "request-application-validation"
                                });
                            }}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>;
    }
}